import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3effa401"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CalculationFilters__form grid gap-3 items-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_button = _resolveComponent("the-button")!

  return (_openBlock(), _createElementBlock("form", {
    class: "CalculationFilters bg-white border px-4 py-2",
    onSubmit: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)), ["prevent"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_the_input, {
        value: _ctx.state.orderCreatedAt,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.orderCreatedAt) = $event)),
        type: "date",
        placeholder: "Дата создания"
      }, null, 8, ["value"]),
      _createVNode(_component_the_input, {
        value: _ctx.state.invoiceNumber,
        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.invoiceNumber) = $event)),
        placeholder: "Номер накладной"
      }, null, 8, ["value"]),
      _createVNode(_component_the_select, {
        placeholder: "Компания",
        loading: _ctx.data_state.companies.is_loading,
        failed: _ctx.data_state.companies.is_failed,
        "error-text": "При получении списка компаний произошла ошибка",
        options: _ctx.data_state.companies.list,
        value: _ctx.state.companyId,
        "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.companyId) = $event)),
        "infinite-scroll": "",
        "search-without-refresh": "",
        onRefresh: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadCompanies(_ctx.data_state.companies.pagination.current_page))),
        onLoadmore: _cache[4] || (_cache[4] = ($event: any) => (_ctx.loadMoreCompanies(_ctx.data_state.companies.pagination.current_page + 1))),
        class: "mt-2"
      }, null, 8, ["loading", "failed", "options", "value"]),
      _createVNode(_component_the_button, {
        class: "second text small mt-2",
        disabled: _ctx.loading,
        onClick: _ctx.reset
      }, {
        default: _withCtx(() => [
          _hoisted_2,
          _createTextVNode(" Сбросить ")
        ]),
        _: 1
      }, 8, ["disabled", "onClick"]),
      _createVNode(_component_the_button, {
        class: "primary text small mt-2",
        loading: _ctx.loading,
        type: "submit"
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Поиск ")
        ]),
        _: 1
      }, 8, ["loading"])
    ])
  ], 32))
}